import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { updateUserProfile } from 'app/redux/store/features/profile'
import ChangePasswordForm from './ChangePasswordForm'
import EditProfileForm from './EditProfileForm'

const EditProfile = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { profile, loading, error } = useSelector((state) => state.profile)
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Profile updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/profile/editprofile')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateEditProfileConfig = (data) => {
        setApiCallInProgress(true)
        dispatch(updateUserProfile(data))
    }

    return (
        <React.Fragment>
            <EditProfileForm updateProfile={onUpdateEditProfileConfig} />
            <ChangePasswordForm />
        </React.Fragment>
    )
}

export default EditProfile
